import { AccordionItem, Text, List, Strong } from 'braid-design-system';
export const IntellectualProperty = () => (
  <AccordionItem id="intellectual-property" label="Intellectual Property">
    <List type="number" start={10}>
      <Text>
        Except to the limited extent expressly provided in these Terms, SEEK
        Limited owns all intellectual property rights, title, and interest in
        and to the SEEK API, including all elements and components of the SEEK
        API.
      </Text>
      <Text>
        Subject to these Terms, SEEK Limited grants you a limited,
        non-exclusive, non-assignable and non-transferable licence to use the
        SEEK API to develop, test, and/or support your Recruitment Software (
        <Strong>Licence</Strong>) for the duration of the Term, and to allow
        Mutual Customers that have engaged you to have the benefit of the
        integration of your Recruitment Software with the SEEK API.
      </Text>
      <Text>
        As between the parties, you own all intellectual property rights, title,
        and interest in and to the Recruitment Software.
      </Text>
      <Text>
        During the Term, you grant to the SEEK Group a royalty-free, worldwide,
        non-exclusive, irrevocable right and licence to your intellectual
        property rights in order to connect Mutual Customers to your Recruitment
        Software and to verify your compliance with these Terms.
      </Text>
    </List>
  </AccordionItem>
);
